import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { TableAction } from '../../../../../services/Main/types.Component';
import TableActionComponent from '../../../../lowLevel/TableAction/TableAction';
import TableActionButton from '../../../../lowLevel/TableAction/TableAction.Button';
import ExtraActions from '../../../../lowLevel/ExtraActions';
import ExtraActionsMenuItem from '../../../../lowLevel/ExtraActions/ExtraActions.MenuItem';
import { useClassifyActions } from '../../../../lowLevel/ExtraActions/useClassifyActions';
import useStyles from './TableSelectionPanel.styles';

interface TableSelectionPanelMobileProps {
  actions?: TableAction[];
  disabled?: boolean;
}

const TableSelectionPanelMobile = ({
  actions,
  disabled = false,
}: TableSelectionPanelMobileProps) => {
  const classes = useStyles();

  const { mainActions, extraActions } = useClassifyActions<TableAction>(
    actions || []
  );

  return (
    <Box className={classes.actionsWrapper}>
      {actions && actions.length > 0 && (
        <Grid container alignItems="center" justify="flex-end" spacing={1}>
          {mainActions.map((actionProps) => (
            <Grid item key={`main_${Object.values(actionProps).join('')}`}>
              <TableActionComponent
                action={actionProps}
                renderAction={TableActionButton}
                disabled={disabled}
              />
            </Grid>
          ))}
          {extraActions.length > 0 ? (
            <Grid item>
              <ExtraActions<TableAction>
                actions={extraActions}
                renderMenuItem={(actionProps, onClickMenuItem) => (
                  <TableActionComponent
                    key={`extraAction_${Object.values(actionProps).join('')}`}
                    action={actionProps}
                    onClick={onClickMenuItem}
                    renderAction={ExtraActionsMenuItem}
                    disabled={disabled}
                  />
                )}
              />
            </Grid>
          ) : null}
        </Grid>
      )}
    </Box>
  );
};

export default TableSelectionPanelMobile;
